module.exports = __webpack_public_path__ + "static/media/check-white-circle.0d552a3d.svg";